(function() {
    'use strict';

    angular
        .module('jotApp')
        .directive('hideColumn', hideColumn);

    function hideColumn () {
        var directive = {
            restrict: 'A',
            scope: {
                hide: '=hideColumn',
                callback: '&'
            },
            controller: HideColumnController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    HideColumnController.$inject = ['$scope', '$element'];

    function HideColumnController ($scope, $element) {
        var vm = this;

        vm.checkCheckbox = checkCheckbox;
        vm.changeVisibility = changeVisibility;

        function checkCheckbox(inp) {

            if (  inp.prop( 'checked') ) {
                inp.prop( 'checked', false );
            } else {
                inp.prop( 'checked', true );
            }
        }

        function changeVisibility(storageName, field) {
            var hideFields = JSON.parse(localStorage.getItem(storageName));
            if(hideFields == null)
                hideFields = [];
            if(hideFields.indexOf(field) > -1)
                hideFields.splice(hideFields.indexOf(field), 1);
            else
                hideFields.push(field);
            localStorage.setItem(storageName, JSON.stringify(hideFields));
            vm.hide[field] = !vm.hide[field];
            $scope.$apply();
        }

    }
})();
